<template>
    <div class="materialExtendItem">
        <i class="icon-jt-yishiyong iconfont primary" v-if="expandMaterial.is_used == '1'"></i>
        <div class="checked">
            <slot name="checkBox"></slot>
        </div>
        <div>
        <div class="item-title">
            <h5>
                <EllipsisTips :value="expandMaterial.material_name"/>
            </h5>
        </div>
        <div class="item-content">
            <div class="view">
                <el-popover
                    placement="left"
                    width="440"
                    trigger="click"
                    v-if="preview"
                >
                    <div class="pop-content">
                        <img v-if="expandMaterial.material_type == 1" :style="{width: '100%'}"
                              :src="show_img"
                        />
                        <video v-else class="" style="width: 100%"
                               :poster="encodeURI(expandMaterial.img_material_url)"
                               :src="encodeURI(expandMaterial.material_url)" loop controls  preload="metadata"></video>`
                    </div>
                    <img class="item-view-img"
                         :src="show_img"
                         v-on:load="imageLoaded" v-on:error="imageFailed" slot="reference"
                    />
                </el-popover>

                <img v-else class="item-view-img"
                     :src="show_img"
                     v-on:load="imageLoaded" v-on:error="imageFailed"  slot="reference" @click="handlePreview"
                />
                <div class="view-con">
                    <el-tooltip class="item" effect="dark" content="素材尺寸" placement="top">
                        <span>{{ expandMaterial.width }} * {{expandMaterial.height}}</span>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="素材大小" placement="top">
                        <span>{{ expandMaterial.material_size }}{{expandMaterial.material_size_unit}}</span>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="素材时长" placement="top" v-if="expandMaterial.material_duration && expandMaterial.material_duration != '-'">
                        <span>{{ expandMaterial.material_duration }}</span>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="素材格式" placement="top">
                        <span>{{ expandMaterial.material_format }}</span>
                    </el-tooltip>
                </div>
            </div>
            <div class="displayText mt10">
                <div class="label">制作人：</div>
                <div class="value">
                    <EllipsisTips :multiline="true" :value="getTextConent"/>
                </div>
            </div>
            <div class="displayText mt10">
                <div class="label">上传时间：</div>
                <div class="value">
                    {{expandMaterial.upload_time}}
                </div>
            </div>
            <div class="displayText mt10" v-if="expandMaterial.refusal_reason">
                <div class="label">拒绝原因：</div>
                <div class="value">
                   <EllipsisTips :value="expandMaterial.refusal_reason"/>
                </div>
            </div>
            <div class="displayTag mt10">
                <div class="left" ref="left">
                    <div ref="left_con" style="display: flex" v-if="expandMaterial?.all_labels && Array.isArray(expandMaterial.all_labels)">
                        <!-- workOrder_v5 需求一：id=-1 为后端按素材分类标签四级归类出的伪标签（多条），level=0 为「未知」用 danger 色，title 带原文 -->
                        <span v-for="(item, index) in expandMaterial.all_labels" :key="index">
                            <el-tag size="mini" effect="plain" :type="item.id ==='-1'?(item.level===0?'danger':'warning'):'info'" :title="item.title || ''">{{item.name}}</el-tag>
                        </span>
                    </div>
                </div>
                <div class="right">
                    <el-popover
                        v-if="moreTags"
                        placement="top"
                        trigger="hover">
                        <div class="pop-content-tag" style="max-width: 440px;">
                            <template v-if="expandMaterial.all_labels && Array.isArray(expandMaterial.all_labels)">
                                <el-tag size="mini" effect="plain" :type="item.id ==='-1'?(item.level===0?'danger':'warning'):'info'" :title="item.title || ''" v-for="(item, index) in expandMaterial.all_labels" :key="index">{{item.name}}</el-tag>
                            </template>
                        </div>
                        <el-tag v-if="moreTags" size="mini" effect="plain" type="info" slot="reference" :style="{cursor: 'pointer'}">更多...</el-tag>
                    </el-popover>
                </div>

            </div>
        </div>
        </div>
        <div class="item-footer mt10">
            <div>
                <el-button type="primary" :class="'material_button_mini_padding'" size="mini" plain @click="handleCopy(expandMaterial.material_md5)" ref="copuMd5"
                v-matomo="{behaviorCategory: fromTitle, event: '点击',  name: '复制MD5' }"
                >复制MD5</el-button>
                <slot name="leftBtn"></slot>
            </div>
            <div>
                <slot name="footer"></slot>
            </div>

        </div>

    </div>
</template>
<script>
import EllipsisTips from "@/views/workOrder/components/ellipsisTips.vue";
import {setClipboard, ellipseShowPromise} from "@/utils"
import noImg from '@/assets/img/mi-no-img.png';
export default {
    name: 'materialExtendItem',
    components: {
        EllipsisTips
    },
    props:{
      fromTitle:{
        type:String,
        default:'素材库(素材管理)',
      },
      expandMaterial: Object,
      tags: Array, //标签循环
      value: String, //标题名称
        preview:{
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            currentName: this.value,
            moreTags: false,
            no_img: noImg,
            show_img: '',
        }
    },
    watch: {
        value(value) {
            this.setCurrentName(value);
        },
        'expandMaterial':{
            handler(n) {
                this.show_img = n.img_material_url ? encodeURI(n.img_material_url) : ''

                this.$nextTick(()=>{
                    let tags_ele = this.$refs.left
                    let tags_ele_con = this.$refs.left_con
                    // console.log('------', tags_ele.clientWidth, tags_ele_con.clientWidth)
                    
                    // 方案一：固定容差值（当前使用）
                    const tolerance = 15 // 容差值，可以根据实际情况调整
                    const availableWidth = tags_ele.clientWidth - tolerance
                    
                    if(availableWidth <= tags_ele_con.clientWidth) {
                        this.moreTags = true
                    }else{
                        this.moreTags = false
                    }
                    
                    // ellipseShowPromise(tags_ele).then(hasEllipsis => {
                    //     if(hasEllipsis) {
                    //         this.moreTags = true
                    //     } else {
                    //         this.moreTags = false
                    //     }
                    // });
                })

            },
            deep: true,
            immediate:true
        }
    },
    computed:{
        getTextConent() {
            let producer_list = this.expandMaterial.producer_list
            let text = ''
            if(Array.isArray(producer_list) && producer_list.length !=0) {
                producer_list.forEach(item=>{
                    let ratio = item.ratio ? (item.ratio * 100).toFixed(2) : ''
                    if(ratio) {
                        text += `${item.name}(${ratio}%);`
                    }else{
                        text += `${item.name};`
                    }
                })
            }else{
                text = '-'
            }
            return text
        },
    },
    mounted() {
        // this.$nextTick(()=>{
        //     let tags_ele = this.$el.querySelector('.left')
        //     ellipseShowPromise(tags_ele).then(hasEllipsis => {
        //         if(hasEllipsis) {
        //             this.moreTags = true
        //         } else {
        //             this.moreTags = false
        //         }
        //     });
        // })
    },

    methods:{

        setCurrentName(value) {
            console.log(value)
            this.currentName = value
            this.$emit('input', value);
        },
        handleClick(value) {
            this.$emit('tab-click', value);
            this.setCurrentName(value)
        },
        handlePreview() {
          if(!this.preview) {
              this.$emit('click-preview')
          }
        },
        handleCopy(md5) {
            setClipboard(md5).then(()=>{
                this.$message.success('复制成功')
            })
        },
        imageLoaded() {
        },
        imageFailed() {
            this.show_img = this.no_img
        },
    }
}
</script>
<style lang="scss" scoped>
    .materialExtendItem{
        border: 1px solid #DCDFE6;
        border-radius: 5px;
        padding: 10px;
        width: 300px;
        height: 410px;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .checked{
            position: absolute;
            top: 16px;
            right: 12px;
        }
        .primary{
            position: absolute;
            color: #67c671;
            font-size: 30px;
        }
        .item-title{
            padding: 6px 30px 16px 50px;
            border-bottom: 1px solid #DCDFE6;
            margin-bottom: 10px;
            h5{
                font-size: 12px;
                font-weight: 600;
                margin: 0;
                padding: 0;
                text-align: center;
            }
        }
        .item-footer{
            display: flex;
            justify-content: space-between;
            .el-button--mini{
                padding: 3px 7px;
            }
        }

        .displayText{
            display: flex;
            width: 100%;
            .label{
                width: 70px;
                flex:  0 0 70px;
            }
            .value{
                flex: 1;
                min-width: 0;
            }
        }
        .view{
            position: relative;
            .item-view-img{
                width: 100%;
                height: 180px;
                object-fit: contain;
                object-position: center;
                cursor: pointer;
            }
            .view-con{
                font-size: 12px;
                position: absolute;
                width: 100%;
                background-color: #ecf5ffc4;
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                padding: 4px;
                bottom: 0;
                span{
                    cursor: pointer;
                }
            }
        }

        .displayTag{
            display: flex;
            width: 100%;

            .left{
                flex: 1;
                min-width: 0;
                overflow: hidden;
                display: flex;
                padding-right: 6px;
                .el-tag{
                    margin-right: 6px;
                }
            }
            .right{
                width: 50px;
                flex:  0 0 50px;
                text-align: right;
            }

        }
        }
</style>
<style lang="scss">
.pop-content-tag{
    .el-tag{
        margin-right: 6px;
        margin-top: 6px;
    }
}
</style>